import React from "react";
import strings from "../../core/translate";
import { getGarageSections, garagesPath } from "../../shared/garage-sections";

// Shown on every page that belongs to a single garage (branch): where you are,
// how to get back to the garages list and how to jump to the other sections.
const GarageSectionHeader = ({
  branchId,
  branchName,
  merchantId,
  active,
  history,
}) => {
  // a garage login already has every section directly in the top nav, so
  // this back-link-plus-tabs bar would just repeat it
  if (!branchId || sessionStorage.getItem("garageBranchId")) return null;

  const sections = getGarageSections(branchId);

  return (
    <div className="garage-subheader">
      <div className="garage-subheader__top">
        <button
          type="button"
          className="garage-subheader__back"
          onClick={() => history.push(garagesPath(merchantId))}
        >
          <i className="nc-icon nc-minimal-left" />
          {strings.back_to_garages}
        </button>
        <div className="garage-subheader__title">
          <i className="nc-icon nc-bank" />
          <span>{branchName || strings.garage}</span>
        </div>
      </div>

      {sections.length > 0 && (
        <div className="garage-subheader__tabs">
          {sections.map((section) => (
            <button
              key={section.key}
              type="button"
              className={`garage-tab${
                section.key === active ? " is-active" : ""
              }`}
              onClick={() => {
                if (section.key !== active) {
                  history.push({
                    pathname: section.path,
                    state: { selectedMerchant: merchantId, branchName },
                  });
                }
              }}
            >
              <i className={section.icon} />
              {section.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default GarageSectionHeader;
